import script from "./MassEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MassEditModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__